import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=a6f6ba90"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=a6f6ba90&prod&lang=scss&module=true"
import style1 from "./DataTable.vue?vue&type=style&index=1&id=a6f6ba90&prod&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports